var React = require('react');

function SubmitAClaim (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_722_7685)","key":0},React.createElement("path",{"d":"M10.5 1.50098H4.5C3.675 1.50098 3.0075 2.17598 3.0075 3.00098L3 15.001C3 15.826 3.6675 16.501 4.4925 16.501H13.5C14.325 16.501 15 15.826 15 15.001V6.00098L10.5 1.50098ZM13.5 15.001H4.5V3.00098H9.75V6.75098H13.5V15.001ZM6 11.2585L7.0575 12.316L8.25 11.131V14.251H9.75V11.131L10.9425 12.3235L12 11.2585L9.0075 8.25098L6 11.2585Z","fill":"currentColor"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_722_7685"},React.createElement("rect",{"width":"18","height":"18","fill":"white"})))]);
}

SubmitAClaim.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = SubmitAClaim;

SubmitAClaim.default = SubmitAClaim;
